import styled from 'styled-components';
import { InputField } from '../FormAuth/style';

export const InputFieldClear = styled(InputField)`
  border: none;
  margin: 0;
  padding: 0;
  border-radius: 0;
`;
